/* Lens reference. Generated by research/build.py, do not edit directly. */
(function () {
  "use strict";
  var root = document.getElementById('lref');
  var dataEl = document.getElementById('lref-data');
  var assetsEl = document.getElementById('lref-assets');
  if (!root || !dataEl || !assetsEl) return;

  var DATA = JSON.parse(dataEl.textContent);
  var ASSETS = JSON.parse(assetsEl.textContent);
  var BY = {};
  DATA.lenses.forEach(function (l) { BY[l.slug] = l; });

  /* i18n: the section embeds a lref-i18n JSON block per locale; English is
     the built-in fallback so a missing block cannot blank the page. */
  var I = {};
  var iEl = document.getElementById('lref-i18n');
  if (iEl) { try { I = JSON.parse(iEl.textContent); } catch (e) {} }
  function T(k, d) { return Object.prototype.hasOwnProperty.call(I, k) ? I[k] : d; }
  function pct(x) { var s = x.toFixed(1); return I.dec ? s.replace('.', I.dec) : s; }

  var MAX = 3;
  var grid = document.getElementById('grid');
  var tray = document.getElementById('tray');
  var slots = document.getElementById('slots');
  var gobtn = document.getElementById('gobtn');
  var dlg = document.getElementById('cmp');
  var picked = [];

  /* ---------- selection ---------- */
  function cardFor(slug) { return grid.querySelector('.lcard[data-slug="' + slug + '"]'); }

  function render() {
    slots.innerHTML = '';
    picked.forEach(function (slug) {
      var d = document.createElement('span');
      d.className = 'slot';
      d.appendChild(document.createTextNode(BY[slug].name));
      var x = document.createElement('button');
      x.type = 'button';
      x.setAttribute('aria-label', T('remove', 'Remove ') + BY[slug].name);
      x.textContent = '\u00d7';
      x.onclick = function () { toggle(slug, false); };
      d.appendChild(x);
      slots.appendChild(d);
    });
    for (var i = picked.length; i < MAX; i++) {
      var e = document.createElement('span');
      e.className = 'slot';
      e.style.opacity = '.38';
      e.textContent = T('empty', 'empty');
      slots.appendChild(e);
    }
    tray.classList.toggle('on', picked.length > 0);
    gobtn.disabled = picked.length < 2;
    gobtn.textContent = picked.length < 2 ? T('pick2', 'Pick two') : T('cmp', 'Compare') + ' ' + picked.length;
    /* Measured, not assumed: the tray wraps to two rows on a phone, and a fixed
       clearance leaves the last card sitting under it. */
    document.body.style.paddingBottom =
      picked.length ? (tray.offsetHeight + 8) + 'px' : '';
  }

  function toggle(slug, on) {
    var i = picked.indexOf(slug);
    if (on && i < 0) {
      /* Full tray: drop the oldest rather than silently ignoring the click. */
      if (picked.length >= MAX) {
        var dropped = picked.shift();
        var dc = cardFor(dropped);
        if (dc) { dc.classList.remove('sel'); dc.querySelector('.cbx').checked = false; }
      }
      picked.push(slug);
    } else if (!on && i >= 0) {
      picked.splice(i, 1);
    }
    var c = cardFor(slug);
    if (c) {
      c.classList.toggle('sel', picked.indexOf(slug) >= 0);
      c.querySelector('.cbx').checked = picked.indexOf(slug) >= 0;
    }
    render();
  }

  grid.addEventListener('change', function (ev) {
    var cb = ev.target.closest('.cbx');
    if (cb) toggle(cb.value, cb.checked);
  });

  document.getElementById('clearbtn').onclick = function () {
    picked.slice().forEach(function (s) { toggle(s, false); });
  };

  /* ---------- sort and filter ---------- */
  var sortsel = document.getElementById('sortsel');
  var famsel = document.getElementById('famsel');
  var countEl = document.getElementById('count');

  function num(v) { return v === '' || v === null ? null : parseFloat(v); }

  function apply() {
    var cards = Array.prototype.slice.call(grid.children);
    var mode = sortsel.value;
    cards.sort(function (a, b) {
      if (mode === 'name') return a.dataset.name.localeCompare(b.dataset.name);
      if (mode === 'cat') {
        /* Uncategorised specimens sort last in either direction. */
        var ca = num(a.dataset.cat), cb2 = num(b.dataset.cat);
        if (ca === null) return 1;
        if (cb2 === null) return -1;
        return ca - cb2;
      }
      /* No stated VLT: fall back to the measured figure so it still lands sensibly. */
      var va = num(a.dataset.vlt), vb = num(b.dataset.vlt);
      if (va === null) va = num(a.dataset.relt);
      if (vb === null) vb = num(b.dataset.relt);
      return mode === 'vlt-asc' ? va - vb : vb - va;
    });
    cards.forEach(function (c) { grid.appendChild(c); });

    var fam = famsel.value, shown = 0;
    cards.forEach(function (c) {
      var vis = fam === 'all' || c.dataset.family === fam;
      c.style.display = vis ? '' : 'none';
      if (vis) shown++;
    });
    countEl.textContent = shown + ' ' + T('of', 'of') + ' ' + cards.length + ' ' + T('shown', 'shown');
  }
  sortsel.onchange = apply;
  famsel.onchange = apply;

  /* ---------- data table sort ---------- */
  var dtable = document.getElementById('dtable');
  var dbody = document.getElementById('dbody');
  var dir = {};
  dtable.querySelectorAll('th[data-k]').forEach(function (th) {
    th.onclick = function () {
      var k = th.dataset.k;
      dir[k] = dir[k] === 'asc' ? 'desc' : 'asc';
      dtable.querySelectorAll('th').forEach(function (o) { o.classList.remove('asc', 'desc'); });
      th.classList.add(dir[k]);
      var rows = Array.prototype.slice.call(dbody.rows);
      rows.sort(function (ra, rb) {
        var a = BY[ra.dataset.slug], b = BY[rb.dataset.slug];
        var x = a[k], y = b[k];
        /* Nulls (variable VLT, no category) always sink, whichever way we sort. */
        if (x === null && y === null) return 0;
        if (x === null) return 1;
        if (y === null) return -1;
        var r = (typeof x === 'number') ? x - y : String(x).localeCompare(String(y));
        return dir[k] === 'asc' ? r : -r;
      });
      rows.forEach(function (r) { dbody.appendChild(r); });
    };
  });

  /* ---------- detail lightbox ---------- */
  var lb = document.getElementById('lb');
  var lbimg = document.getElementById('lbimg');
  var lbcap = document.getElementById('lbcap');
  var lbtitle = document.getElementById('lbtitle');
  var lbBtns = { out: document.getElementById('lbout'), sun: document.getElementById('lbsun') };
  var lbSlug = null;
  var lbView = 'out';

  /* Navigation order follows the grid as currently sorted and filtered, so
     paging through the lightbox matches what the reader sees behind it. */
  function lbOrder() {
    var vis = Array.prototype.slice.call(grid.children)
      .filter(function (c) { return c.style.display !== 'none'; })
      .map(function (c) { return c.dataset.slug; });
    return vis.indexOf(lbSlug) >= 0
      ? vis
      : DATA.lenses.map(function (l) { return l.slug; });
  }

  function lbStep(dir) {
    var order = lbOrder();
    var i = order.indexOf(lbSlug);
    if (i < 0) return;
    lbShow(order[(i + dir + order.length) % order.length], lbView);
  }

  function lbShow(slug, view) {
    var l = BY[slug];
    if (!l || !ASSETS[slug] || !ASSETS[slug][view]) return;
    lbSlug = slug;
    lbView = view;
    lbimg.src = ASSETS[slug][view];
    if (view === 'out') {
      lbimg.alt = T('extalt', '{n} lens seen from the front. Exterior mirror: {m}')
        .replace('{n}', l.name).replace('{m}', l.mirror);
      lbcap.textContent = l.sid + ' \u00b7 ' + T('lbout',
        'Exterior, full frame from the sun block. Mirror:') + ' ' + l.mirror + '.';
    } else {
      lbimg.alt = T('thrualt', 'View through the {n} lens: {t}')
        .replace('{n}', l.name).replace('{t}', l.tint);
      lbcap.textContent = l.sid + ' \u00b7 ' + T('lbsun',
        'Through the lens, full frame from the sun block. Tint:') + ' ' + l.tint + '. '
        + T('lbmeas', 'Measured') + ' ' + pct(l.relT) + T('lbctl', '% of the clear control.');
    }
    lbtitle.textContent = l.name;
    Object.keys(lbBtns).forEach(function (k) {
      lbBtns[k].classList.toggle('on', k === view);
    });
    if (!lb.open) lb.showModal();
  }

  lbBtns.out.onclick = function () { lbShow(lbSlug, 'out'); };
  lbBtns.sun.onclick = function () { lbShow(lbSlug, 'sun'); };
  document.getElementById('lbprev').onclick = function () { lbStep(-1); };
  document.getElementById('lbnext').onclick = function () { lbStep(1); };
  document.getElementById('lbclose').onclick = function () { lb.close(); };
  lb.addEventListener('click', function (ev) {
    /* A click on the backdrop lands on the dialog element itself. */
    if (ev.target === lb) lb.close();
  });
  lb.addEventListener('keydown', function (ev) {
    if (ev.key === 'ArrowLeft') { ev.preventDefault(); lbStep(-1); }
    else if (ev.key === 'ArrowRight') { ev.preventDefault(); lbStep(1); }
  });

  grid.addEventListener('click', function (ev) {
    var c = ev.target.closest('.lcard');
    if (!c) return;
    var onExt = !!ev.target.closest('.ext');
    if (!onExt && !ev.target.closest('.sw')) return;
    /* Clicking a specimen goes to its review page, which is what a reader
       wants from a lens they just picked out of the grid. The lightbox stays
       for the counterfeits, which have no page of their own. */
    if (c.dataset.review) { window.location.href = c.dataset.review; return; }
    lbShow(c.dataset.slug, onExt ? 'out' : 'sun');
  });

  /* ---------- comparison ---------- */
  var ROWS = [
    { k: 'against', label: T('auth', 'Authenticity'), fmt: function (l) {
        return l.against
          ? '<span class="tag alert">' + T('faketag', 'counterfeit') + '</span> ' + T('bought', 'bought as genuine')
          : T('genuine', 'Genuine'); } },
    { k: 'vltStated', label: T('vlt', 'VLT stated'), fmt: function (l) {
        if (l.vltStated !== null) return l.vltStated + '%';
        return '<span class="na">' + (l.against ? T('notstated', 'not stated') : T('variable', 'variable')) + '</span>'; } },
    { k: 'category', label: T('cat', 'Category'), fmt: function (l) {
        return l.category === null ? '<span class="na">n/a</span>' : 'CAT ' + l.category; } },
    { k: 'relT', label: T('meas', 'Measured'), fmt: function (l) { return pct(l.relT) + '%'; } },
    { k: 'hex', label: T('col', 'Sampled colour'), fmt: function (l) {
        return '<i class="chip" style="background:' + l.hex + '"></i><code>' + l.hex + '</code>'; } },
    { k: 'tint', label: T('tintl', 'Look through'), fmt: function (l) { return l.tint; } },
    { k: 'mirror', label: T('mirrorl', 'Mirror'), fmt: function (l) { return l.mirror; } },
    { k: 'light', label: T('lightl', 'Light'), fmt: function (l) { return l.light; } },
    { k: 'activity', label: T('act', 'Suited to'), fmt: function (l) { return l.activity; } },
    { k: 'rxInsert', label: T('rx', 'Rx insert'), fmt: function (l) {
        if (l.rxInsert === null) return '<span class="na">' + T('na', 'n/a') + '</span>';
        return l.rxInsert ? T('avail', 'Available') : T('notavail', 'Not available'); } },
    { k: 'note', label: T('notes', 'Notes'), fmt: function (l) { return l.note; } }
  ];

  function build(slugs) {
    var ls = slugs.map(function (s) { return BY[s]; }).filter(Boolean);
    if (ls.length < 2) return '';
    var h = '<div class="cmpscroll"><table class="cmp"><colgroup><col class="labcol">';
    ls.forEach(function () { h += '<col>'; });
    h += '</colgroup><tbody>';

    h += '<tr class="imgrow"><th class="rowlab" scope="row">' + T('thru', 'Through') + '</th>';
    ls.forEach(function (l) {
      h += '<td><span class="csid">' + l.sid + '</span>' +
           '<span class="cname">' + l.name + '</span>' +
           '<img src="' + ASSETS[l.slug].through + '" style="margin-top:10px" ' +
           'data-lbs="' + l.slug + '" data-lbv="sun" ' +
           'alt="' + T('thrualt', 'View through the {n} lens: {t}').replace('{n}', l.name).replace('{t}', l.tint) + '"></td>';
    });
    h += '</tr>';

    h += '<tr class="imgrow"><th class="rowlab" scope="row">' + T('out', 'Outside') + '</th>';
    ls.forEach(function (l) {
      h += '<td><img src="' + ASSETS[l.slug].ext + '" ' +
           'data-lbs="' + l.slug + '" data-lbv="out" ' +
           'alt="' + T('extalt', '{n} lens seen from the front. Exterior mirror: {m}').replace('{n}', l.name).replace('{m}', l.mirror) + '"></td>';
    });
    h += '</tr>';

    ROWS.forEach(function (row) {
      var vals = ls.map(function (l) { return String(l[row.k]); });
      var same = vals.every(function (v) { return v === vals[0]; });
      h += '<tr class="' + (same ? 'same' : 'diff') + '">' +
           '<th class="rowlab" scope="row">' + row.label + '</th>';
      ls.forEach(function (l) { h += '<td>' + row.fmt(l) + '</td>'; });
      h += '</tr>';
    });

    h += '</tbody></table></div>';
    h += '<p class="cmpnote">' + T('cmpnote', 'Highlighted rows differ between the specimens shown. ' +
         '<b>Measured</b> is this study, relative to the clear control under one locked ' +
         'exposure, and is camera relative rather than a lab VLT. <b>VLT stated</b> and ' +
         '<b>Category</b> derive from Oakley\u2019s published figures.') + '</p>';
    return h;
  }

  function open(slugs) {
    var html = build(slugs);
    if (!html) return;
    document.getElementById('cmpout').innerHTML = html;
    document.getElementById('cmptitle').textContent =
      slugs.map(function (s) { return BY[s].name; }).join(T('vs', '  vs  '));
    if (!dlg.open) dlg.showModal();
    var u = new URL(location.href);
    u.searchParams.set('compare', slugs.join(','));
    history.replaceState(null, '', u);
  }

  gobtn.onclick = function () { open(picked); };
  document.getElementById('cmpout').addEventListener('click', function (ev) {
    var im = ev.target.closest('img[data-lbs]');
    if (im) lbShow(im.dataset.lbs, im.dataset.lbv);
  });
  document.getElementById('closebtn').onclick = function () { dlg.close(); };
  document.getElementById('diffonly').onchange = function () {
    root.classList.toggle('hidesame', this.checked);
  };
  dlg.addEventListener('close', function () {
    var u = new URL(location.href);
    u.searchParams.delete('compare');
    history.replaceState(null, '', u);
  });

  document.getElementById('sharebtn').onclick = function () {
    var btn = this;
    var done = function (ok) {
      btn.textContent = ok ? T('copied', 'Copied') : T('press', 'Press \u2318C');
      setTimeout(function () { btn.textContent = T('copy', 'Copy link'); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(location.href).then(function () { done(true); },
                                                        function () { done(false); });
    } else { done(false); }
  };

  /* ---------- restore a shared comparison ---------- */
  var q = new URLSearchParams(location.search).get('compare');
  if (q) {
    q.split(',').filter(function (s) { return BY[s]; }).slice(0, MAX)
      .forEach(function (s) { toggle(s, true); });
    if (picked.length >= 2) open(picked);
  }

  apply();
  render();
})();
